






































import { Component, Vue, Emit } from 'vue-property-decorator';
import { TaskFilterPeriodQuery } from '@/@types/LibraryComponent';

@Component
export default class TaskFilterPeriodCheckbox extends Vue {
  private day: boolean = false;
  private week: boolean = false;
  private month: boolean = false;
  private isPeriod: boolean = false;
  private onChangeDay() {
    this.week = false;
    this.month = false;
    this.isPeriod = false;
    this.emitSortQuery();
  }
  private onChangeWeek() {
    this.day = false;
    this.month = false;
    this.isPeriod = false;
    this.emitSortQuery();
  }
  private onChangeMonth() {
    this.day = false;
    this.week = false;
    this.isPeriod = false;
    this.emitSortQuery();
  }
  private onChangeIsPeriod() {
    this.day = false;
    this.week = false;
    this.month = false;
    this.emitSortQuery();
  }
  @Emit('emitSortQuery')
  private emitSortQuery(): TaskFilterPeriodQuery {
    return {
      day: this.day,
      week: this.week,
      month: this.month,
      isPeriod: this.isPeriod,
    };
  }
}
